// UserContext.js
import React, { createContext, useState, useContext } from 'react';

const ItemListContext = createContext();

export const UseItemListProvider = ({ children }) => {
  const [ alItemsList, setAllitemsList] = useState([]);

//   const itemList = (user) => {
//     setAllitemsList(user);
//   };

  return (
    <ItemListContext.Provider value={{ alItemsList, setAllitemsList }}>
      {children}
    </ItemListContext.Provider>
  );
};

export const UseItemList = () => {
  const context = useContext(ItemListContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
